import { gql } from "lib/apolloClient";
import { courseOverviewCountFragments } from "./Fragments";
import {
  plannerElementNodeFragment,
  pypElementFragment,
} from "modules/CommonFragments";

export const getCourseOverviewElementSetsNotCoveredCountQuery = gql`
  query getCourseOverviewElementSetsNotCoveredCount(
    $id: ID!
    $filters: InsightCurriculumFilter!
  ) {
    node(id: $id, type: COURSE) {
      id
      ... on Course {
        id
        genericYearlyInsight(filters: $filters) {
          elementSetsNotCovered {
            ...elementSetCoverageCount
          }
          elementSetsCovered {
            ...elementSetCoverageCount
          }
        }
      }
    }
  }
  ${courseOverviewCountFragments.elementSetCoverageCount}
`;

export const getPlannerElementNodesQuery = gql`
  query getPlannerElementNodes($ids: [ID!]) {
    multiNode(ids: $ids, type: PLANNER_ELEMENT_NODE) {
      id
      ... on PlannerElementNode {
        ...plannerElementNodeItem
      }
    }
  }
  ${plannerElementNodeFragment.plannerElementNode}
`;

export const getPYPYearlyInsightsQuery = gql`
  query getPYPYearlyInsights(
    $id: ID!
    $filters: PYPCourseYearlyInsightFilters
  ) {
    node(id: $id, type: COURSE) {
      id
      ... on Course {
        id
        pypYearlyInsight(filters: $filters) {
          ... on ATLYearlyInsight {
            type
            elementsNotCovered {
              elements {
                id
                label
                children
                parent
                isLeaf
                atlCategory {
                  id
                }
                subText
                grades {
                  id
                  name
                }
              }
              leafNodeCount
            }
            elementsCovered {
              leafNodeCount
            }
          }
          ... on KeyConceptYearlyInsight {
            type
            elementsNotCovered_: elementsNotCovered {
              elements {
                ...conceptItem
              }
              leafNodeCount
            }
            elementsCovered {
              leafNodeCount
            }
          }
          ... on BenchmarkYearlyInsight {
            type
            elementsNotCovered {
              elements {
                id
                label
                children
                parent
                subject
                levelId
                displaySequence
                depth
                type
                isLeaf
                levels {
                  id
                  value
                  count
                }
              }
              leafNodeCount
            }
            elementsCovered {
              elements {
                id
                label
                children
                parent
                subject
                levelId
                displaySequence
                depth
                type
                isLeaf
                parent
                levels {
                  id
                  value
                  count
                }
              }
              leafNodeCount
            }
          }
          ... on LPAYearlyInsight {
            type
            elementsNotCovered_: elementsNotCovered {
              elements {
                ...lpItem
              }
              leafNodeCount
            }
            elementsCovered {
              leafNodeCount
            }
          }
        }
      }
    }
  }
  ${pypElementFragment.concept}
  ${pypElementFragment.lp}
`;

export const getCourseOverviewDownloadQuery = gql`
  query getCourseOverviewDownload(
    $id: ID!
    $filters: CourseOverviewDownloadFilters
  ) {
    node(id: $id, type: COURSE) {
      id
      ... on Course {
        id
        courseOverviewDownload(filters: $filters) {
          isSuccess
          url
        }
        __typename
      }
      __typename
    }
  }
`;
